<template>
  <vx-card style="padding-left: 10px">
    <div class="vx-col lg:w-1/2" align="left">
    </div>

    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        :sst="true"
        :total="totalDocs"
        :data="supplierData"
        @search="handleSearch"
        @change-page="handleChangePage"
        @sort="handleSort"
        :max-items="dataTableParams.limit"
        search
        :noDataText="noDataText"
      >
        <div slot="header" class="flex flex-wrap-reverse flex-grow justify-between">
          <div style="float: left">
            <vs-select
              placeholder="10"
              vs-multiple
              autocomplete
              v-model="dataTableParams.limit"
              class="mr-6"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in limitOptions"
                :clearable="false"
              />
            </vs-select>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="name">Suppliers Name</vs-th>
          <vs-th>No of Products</vs-th>
          <vs-th>No of Orders</vs-th>
          <vs-th>No of Past Orders</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name | capitalize">
              {{
                data[indextr].name
              }}
            </vs-td>
            <vs-td :data="data[indextr].productCount">
              {{
                data[indextr].productCount
              }}
            </vs-td>
            <vs-td :data="data[indextr].orderCount">
              {{
                data[indextr].orderCount
              }}
            </vs-td>
            <vs-td :data="data[indextr].orderCount">
              {{
                data[indextr].orderCount
              }}
            </vs-td>
            <vs-td :data="data[indextr]._id">
              <vx-tooltip text="View Supplier Details" position="left" >
                <vs-button
                  type="border"
                  size="small"
                  @click="viewSupplierDetails(data[indextr]._id)"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="mr-2"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
           </vs-tr>
        </template>
      </vs-table>
      <span class="mr-2">
        {{
          dataTableParams.page * dataTableParams.limit -
          (dataTableParams.limit - 1)
        }}
        -
        {{
          totalDocs - dataTableParams.page * dataTableParams.limit > 0
            ? dataTableParams.page * dataTableParams.limit
            : totalDocs
        }}
        of {{ totalDocs }}
      </span>
      <div class="pagination-div" v-if="serverResponded">
        <paginate
          :page-count="totalPage"
          :click-handler="handleChangePage"
          class="pagination"
          :page-range="9"
          :prevText="'<'"
          :nextText="'>'"
        ></paginate>
      </div>
    </div>
  </vx-card>
</template>

<script>

export default {
  name: 'SuppliersList',
  components: {
  },
  props: ['supplierData', 'totalDocs', 'page', 'noDataText','popUpDeleteParent'],
  data() {
    return {
      popUpDelete: this.popUpDeleteParent,
      isMounted: false,
      currentPage: 1,
      popupData:{
        id:'',
        productData:[],
        subCategoryData: [],
      },
      dataTableParams: {
        search: '',
        sort: 'createdAt',
        dir: 'desc',
        page: 1,
        limit: 10,
      },
      limitOptions: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
      ],
      serverResponded: false,
      awaitingSearch: null,
    };
  },
  methods: {
    async fetchList() {
      this.$vs.loading();
      await this.$emit('fetchList', this.dataTableParams);
      this.serverResponded = true;
      this.$vs.loading.close();
    },
    viewSupplierDetails(id) {
      this.$emit('viewSupplierDetail', id);
    },
    openDeletePopup(id,productData, subCategoryData){
      this.popupData.id = id;
      this.popupData.productData = productData;
      this.popupData.subCategoryData = subCategoryData;
      this.popUpDelete=true;
    },
    handleSearch(searching) {
      if (this.awaitingSearch) {
        clearTimeout(this.awaitingSearch);
        this.awaitingSearch = null;
      }
      this.awaitingSearch = setTimeout(() => {
        this.serverResponded = false;
        this.dataTableParams.search = searching;
        this.dataTableParams.page = 1;
        this.$refs.table.currentx = 1;
        this.fetchList();
      }, 500);
    },
    handleChangePage(page) {
      this.dataTableParams.page = page;
      this.fetchList();
    },
    handleSort(key, active) {
      this.serverResponded = false;
      this.dataTableParams.sort = key;
      this.dataTableParams.dir = active;
      this.dataTableParams.page = 1;
      this.$refs.table.currentx = 1;
      this.fetchList();
    },
  },
  watch: {
    'dataTableParams.page': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dataTableParams.page = newVal;
        this.fetchList();
      }
    },
    'dataTableParams.limit': function(newlimit, oldLimit) {
      if (newlimit !== oldLimit) {
        this.serverResponded = false;
        this.dataTableParams.page = 1;
        this.dataTableParams.limit = newlimit;
        this.fetchList();
      }
    },
  },
  computed: {
    totalPage: function() {
      return this.totalDocs / this.dataTableParams.limit >
      parseInt(this.totalDocs / this.dataTableParams.limit)
        ? parseInt(this.totalDocs / this.dataTableParams.limit) + 1
        : parseInt(this.totalDocs / this.dataTableParams.limit);
    },
  },
  created() {
    this.noDataText = 'Loading...';
    this.fetchList();
  },
};
</script>
